import { Component, Input } from '@angular/core';
var LinkComponent = /** @class */ (function () {
    function LinkComponent() {
        /**
         * level of the title
         */
        this.href = '#';
        /**
         * level of the title
         */
        this.target = '_self';
    }
    /**
     * Implementation of Angular's OnInit lifecyvle hook
     */
    LinkComponent.prototype.ngOnInit = function () {
        this.validateInputs();
    };
    LinkComponent.prototype.handleClick = function (event) {
        event.stopPropagation();
    };
    /**
     * Validate the input binding properties.
     */
    LinkComponent.prototype.validateInputs = function () {
        // check text
        if (!this.text) {
            console.log("LinkComponent - Validation Warning for link-text (text: " + this.text + "): No text for <a> - <a> is empty => removed from DOM");
        }
        // check href
        if (!this.href) {
            this.href = '#';
            console.log("LinkComponent - Validation Warning for href (text: " + this.href + "): No href for <a> - href set to default (" + this.href + ")");
        }
        // check target
        if (this.target && this.target === '_blank' && !this.rel) {
            console.log("LinkComponent - Validation Warning for target (target: " + this.target + "): Noopener & Noreferrer string is missing");
        }
    };
    LinkComponent.decorators = [
        { type: Component, args: [{
                    selector: 'cov-link',
                    template: "<a *ngIf=\"text\" class=\"a-link {{ modifier && 'a-link--' + modifier || ''}} {{ class }}\"\r\n   (click)=\"handleClick($event)\"\r\n   [href]=\"href || ''\"\r\n   [title]=\"title || ''\"\r\n   [target]=\"target || ''\"\r\n   data-t-name=\"Link\"\r\n   [attr.data-t-decorator]=\"decorator\">\r\n   <span [innerHTML]=\"text\"></span>\r\n</a>\r\n"
                }] }
    ];
    /** @nocollapse */
    LinkComponent.ctorParameters = function () { return []; };
    LinkComponent.propDecorators = {
        modifier: [{ type: Input }],
        decorator: [{ type: Input }],
        href: [{ type: Input }],
        target: [{ type: Input }],
        rel: [{ type: Input }],
        text: [{ type: Input }],
        title: [{ type: Input }],
        class: [{ type: Input }]
    };
    return LinkComponent;
}());
export { LinkComponent };
//# sourceMappingURL=link.component.js.map